import * as modalDialog from "modalDialog";

export const setup = (actionsDropdown, checkboxes) => {
  checkboxes.change(() => {
    if (checkboxes.filter(":checked").length > 0) {
      actionsDropdown.find(".dropdownButton").prop("disabled", false);
    } else {
      actionsDropdown.find(".dropdownButton").prop("disabled", true);
    }
  });
  actionsDropdown
    .find(".dropdownButton")
    .off()
    .click(() => {
      modalDialog.show(actionsDropdown.find(".dropdownButtonList"), {
        center: false,
        closeButton: false,
      });
    });
};
